// Application Configuration

// Default configuration
const DEFAULT_CONFIG = {
  mode: 'multi', // 'single' or 'multi'
  singleNetworkSubdomain: null, // subdomain for single network mode
};

class AppConfig {
  constructor() {
    this.config = { ...DEFAULT_CONFIG };
    this.initFromURL();
  }

  // Initialize configuration from URL parameters
  initFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    // Check for mode parameter (?mode=single or ?mode=multi)
    const modeParam = urlParams.get('mode');
    if (modeParam === 'single' || modeParam === 'multi') {
      this.config.mode = modeParam;

      // Store in sessionStorage to persist across page navigation
      sessionStorage.setItem('appMode', modeParam);
    } else {
      // Check sessionStorage for persisted mode
      const storedMode = sessionStorage.getItem('appMode');
      if (storedMode === 'single' || storedMode === 'multi') {
        this.config.mode = storedMode;
      }
    }

    // Check for network parameter for single network mode
    const networkParam = urlParams.get('network');
    if (networkParam) {
      this.config.singleNetworkSubdomain = networkParam;
      sessionStorage.setItem('singleNetworkSubdomain', networkParam);
    } else {
      const storedNetwork = sessionStorage.getItem('singleNetworkSubdomain');
      if (storedNetwork) {
        this.config.singleNetworkSubdomain = storedNetwork;
      }
    }
  }

  // Get current mode
  getMode() {
    return this.config.mode;
  }

  // Check if in single network mode
  isSingleNetworkMode() {
    return this.config.mode === 'single';
  }

  // Check if in multi network mode
  isMultiNetworkMode() {
    return this.config.mode === 'multi';
  }

  // Get single network subdomain
  getSingleNetworkSubdomain() {
    return this.config.singleNetworkSubdomain;
  }

  // Set mode programmatically
  setMode(mode) {
    if (mode === 'single' || mode === 'multi') {
      this.config.mode = mode;
      sessionStorage.setItem('appMode', mode);
    }
  }

  // Set single network subdomain
  setSingleNetworkSubdomain(subdomain) {
    this.config.singleNetworkSubdomain = subdomain;
    sessionStorage.setItem('singleNetworkSubdomain', subdomain);
  }

  // Reset to defaults
  reset() {
    this.config = { ...DEFAULT_CONFIG };
    sessionStorage.removeItem('appMode');
    sessionStorage.removeItem('singleNetworkSubdomain');
  }
}

// Create singleton instance
const appConfig = new AppConfig();

export default appConfig;
